import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/price-library")({
  staticData: { title: "Price Library" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/price-library/page.tsx"),
    "PriceLibrary",
  ),
})
